module.exports = __webpack_public_path__ + "img/005.9e0b3d60.jpg";